import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { MdMobileFriendly } from 'react-icons/md';
import axios from 'axios';
import { web_url } from '../../constant';

const url = "http://localhost:8080/api/";

function TeacherSignUp2() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setChecked(false);
        setOpen(false);
    };

    const handleAgree = () => {
        setChecked(true);
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const [teacherSignupDetails, setteacherSignupDetails] = useState(
        {
            school: '',
            grade: '',
            class: '',
            mobileNumber: '',
        }
    )

    useEffect(() => {
        localStorage.removeItem('teachersignup2');
    }, [])

    const [errors, setErrors] = useState(
        {
            noSchool: false,
            noGrade: false,
            noClass: false,
            noMobileNumber: false,
            noValidMobileNumber: false,
            noAgree: false
        }
    )

    const [teacherDetails, setTeacherDetails] = useState(() => {
        const teacher1 = localStorage.getItem('teachersignup1') ? JSON.parse(localStorage.getItem('teachersignup1')) : {};
        return teacher1;
    })

    const [schoolArray, setSchoolArray] = useState(['Royal college colombo', 'Royal college Negombo', 'Royal college Kandy',]);
    const gradeArray = ['6', '7', '8', '9', '10', '11', '12'];
    const classArray = ['a', 'b', 'c', 'd', 'e', 'f'];

    const [checked, setChecked] = useState(false);

    const [open2, setOpen2] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };

    const [openError, setOpenError] = useState(false);

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('no double')) {
            setError(t('t348'));
        } else if (err.toLowerCase().includes('no pending invitation found')) {
            setError(t('t127_3'));
        } else if (err.toLowerCase().includes('email is already taken')) {
            setError(t('t92'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        localStorage.removeItem('/teacherpersonaldetails')
        setOpenError(false);
        navigate('/loginpage');
    };

    const [error, setError] = useState(null);

    useEffect(() => {
        if (localStorage.getItem('teachersignup1')) {
            const districtLoad = localStorage.getItem('teachersignup1') ? JSON.parse(localStorage.getItem('teachersignup1')).district : "Jaffna";
            const apiUrl = `${web_url}/api/auth/schools?district=${districtLoad}`
            axios.get(apiUrl)
                .then((response) => {
                    const schoolArrayNew = response.data.map((school) => school.name);
                    setSchoolArray(schoolArrayNew);
                })
                .catch((err) => {
                    setError(err.message);
                    console.log("error:", err.message);
                });
        } else {
            navigate('/teacherpersonaldetails')
        }
    }, []);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            localStorage.removeItem('teachersignup1')
            localStorage.removeItem('teachersignup2')
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    const handleContinue = () => {
        let newErrors = {};

        newErrors.noSchool = !teacherSignupDetails.school;
        newErrors.noGrade = !teacherSignupDetails.grade;
        newErrors.noClass = !teacherSignupDetails.class;
        newErrors.noMobileNumber = !teacherSignupDetails.mobileNumber;

        const mobileRegex = /^07\d{8}$/;
        if (teacherSignupDetails.mobileNumber && !mobileRegex.test(teacherSignupDetails.mobileNumber)) {
            newErrors.noValidMobileNumber = true;
        } else {
            newErrors.noValidMobileNumber = false;
        }

        newErrors.noAgree = !checked;

        setErrors(newErrors);

        if (Object.values(newErrors).some((error) => error)) {
            return;
        }

        const teacher = {
            userEmail: teacherDetails.email,
            userFullName: teacherDetails.name,
            userPassword: teacherDetails.password,
            district: teacherDetails.district,
            school: teacherSignupDetails.school,
            assignedClass: `${teacherSignupDetails.grade}-${teacherSignupDetails.class}`,
            contactNumber: teacherSignupDetails.mobileNumber,
        };

        setIsLoading(true);
        // const apiUrl = `${url}auth/teachers`;
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };

        const filterDetails = {
            receiverEmail: teacherDetails.email,
            invitationStatus: "PENDING",
            userRole: "TEACHER"
        }

        const filterDetailsSchool = {
            school: teacherDetails.school,
            district: teacherDetails.district,
            assignedClass: `${teacherSignupDetails.grade}-${teacherSignupDetails.class}`
        }

        // axios.post(`${web_url}/api/auth/teachers/filter`, filterDetailsSchool, config).then((resSchl) => {
        //     if (resSchl.data.length > 0) {

        //         setIsLoading(false);
        //         handleClickOpenError("no double");
        //     } else {
        //         console.log('newnew fail');
        //         axios.post(`${web_url}/api/invitations/admin/filter`, filterDetails, config).then((resInv) => {

        //             if (resInv.data.length === 0) {
        //                 handleClickOpenError("invitation not found");
        //                 setIsLoading(false);
        //             } else {
        //                 axios.post(`${web_url}/api/auth/teachers`, teacher, config)
        //                     .then((response) => {
        //                         // console.log("API Response:", response.data);
        //                         axios.put(`${web_url}/api/invitations/admin/${resInv.data[0].id}/status`).then((resDelInv) => {
        //                             setIsLoading(false);
        //                             handleClickOpen2();
        //                         }).catch((resDelErr) => {
        //                             if (resDelErr.response) {
        //                                 if (resDelErr.response.data.error) {
        //                                     handleClickOpenError(resDelErr.response.data.error);
        //                                 } else if (resDelErr.response.data.message) {
        //                                     handleClickOpenError(resDelErr.response.data.message);
        //                                 } else {
        //                                     handleClickOpenError("An unknown error occured");
        //                                 }
        //                             } else if (resDelErr.request) {
        //                                 const errorMessage = "No response from the server. Please check your network connection.";
        //                             } else {
        //                                 const errorMessage = resDelErr.message;
        //                             }
        //                             setIsLoading(false);
        //                         })
        //                     })
        //                     .catch((err) => {
        //                         if (err.response) {
        //                             if (err.response.data.error) {
        //                                 handleClickOpenError(err.response.data.error);
        //                             } else if (err.response.data.message) {
        //                                 handleClickOpenError(err.response.data.message);
        //                             } else {
        //                                 handleClickOpenError("An unknown error occured");
        //                             }

        //                         } else if (err.request) {
        //                             const errorMessage = "No response from the server. Please check your network connection.";
        //                         } else {
        //                             const errorMessage = err.message;
        //                         }
        //                         setIsLoading(false);
        //                     })
        //             }

        //         }).catch((errInv) => {
        //             setIsLoading(false);
        //             if (errInv.response) {
        //                 // console.log(err.response)
        //                 if (errInv.response.data.error) {
        //                     handleClickOpenError(errInv.response.data.error);
        //                 } else if (errInv.response.data.message) {
        //                     handleClickOpenError(errInv.response.data.message);
        //                 } if (errInv.response.data.token) {
        //                     handleClickOpenError(errInv.response.data.token);
        //                 } else {
        //                     handleClickOpenError("An unknown error occured");
        //                 }

        //             }
        //         })
        //     }
        // }).catch((errSchl) => {
        //     setIsLoading(false);
        //     if (errSchl.response) {
        //         // console.log(err.response)
        //         if (errSchl.response.data.error) {
        //             handleClickOpenError(errSchl.response.data.error);
        //         } else if (errSchl.response.data.message) {
        //             handleClickOpenError(errSchl.response.data.message);
        //         } if (errSchl.response.data.token) {
        //             handleClickOpenError(errSchl.response.data.token);
        //         } else {
        //             handleClickOpenError("An unknown error occured");
        //         }

        //     }
        // })

        axios.post(`${web_url}/api/auth/register/teachers`, teacher, config)
            .then((response) => {
                // console.log("API Response:", response.data);
                setIsLoading(false);
                handleClickOpen2();
            })
            .catch((err) => {
                if (err.response) {
                    if (err.response.data.error) {
                        handleClickOpenError(err.response.data.error);
                    } else if (err.response.data.message) {
                        handleClickOpenError(err.response.data.message);
                    } else {
                        handleClickOpenError("An unknown error occured");
                    }

                } else if (err.request) {
                    const errorMessage = "No response from the server. Please check your network connection.";
                } else {
                    const errorMessage = err.message;
                }
                setIsLoading(false);
            })



    };


    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge bg-no-repeat bg-cover min-h-screen w-screen flex flex-col justify-center pl-[30px] pr-[30px] md:items-center`}>
            <Menu as="div" className="absolute top-0 right-0 m-[10px] text-left items-right">
                <div>
                    <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                        {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("English");
                                    changeLanguage('en')
                                }}
                            >
                                English
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Sinhala");
                                    changeLanguage('si')
                                }}
                            >
                                සිංහල
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Tamil");
                                    changeLanguage('ta')
                                }}
                            >
                                தமிழ்
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </Menu>
            <div className='flex flex-col justify-center h-full sm:w-full sm:w-full md:w-[400px] lg:w-[500px] xl:w-[500px]  2xl:w-[500px] mt-[10px]'>
                <img src="/images/logo.svg" className="h-[150px]" alt='logo' />
                <p className="text-center text-[30px] mt-[10px]">{t('t1')}</p>
                <p className='mt-[20px] text-[16px] font-bold text-[#FDC50C]'>{t('t357')}</p>


                <div className="items-center mt-[10px] flex h-[50px] md:h-[60px] xl:h-[50px] 2xl:h-[60px]">
                    <Menu as="div" className="w-full relative inline-block text-left py-[20px]">
                        <div>
                            <MenuButton
                                className={`truncate pl-[20px] inline-flex w-full justify-left items-center rounded-md bg-[#F1F6FB] h-[50px] md:h-[60px] xl:h-[50px] 2xl:h-[60px] text-[15px] ${teacherSignupDetails.school === "" ? 'text-gray-500' : 'text-gray-900'} shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px]`}
                            >
                                {teacherSignupDetails.school === "" ? t('t33') : teacherSignupDetails.school}
                                <ChevronDownIcon
                                    aria-hidden="true"
                                    className="absolute right-[10px] size-5 text-gray-700"
                                />
                            </MenuButton>
                        </div>

                        <MenuItems
                            transition
                            className="absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                            style={{
                                width: '100%',
                                maxHeight: '150px',
                                overflowY: 'auto'
                            }}
                        >
                            <div className="py-1">
                                {
                                    schoolArray.map((schoolSelect, index) => (
                                        <MenuItem key={index}>
                                            <button
                                                className="truncate text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                                onClick={() => {
                                                    setteacherSignupDetails((prev) => ({ ...prev, school: schoolSelect }))
                                                }}
                                            >
                                                {schoolSelect}
                                            </button>
                                        </MenuItem>
                                    ))
                                }
                            </div>
                        </MenuItems>
                    </Menu>
                </div>

                {errors.noSchool &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t34')}</p>
                }

                <div className="items-center mt-[20px] flex h-[50px] md:h-[60px] xl:h-[50px] 2xl:h-[60px]">
                    <Menu as="div" className="w-full relative inline-block text-left py-[20px]">
                        <div>
                            <MenuButton
                                className={`truncate pl-[20px] inline-flex w-full justify-left items-center rounded-md bg-[#F1F6FB] h-[50px] md:h-[60px] xl:h-[50px] 2xl:h-[60px] text-[15px] ${teacherSignupDetails.grade === "" ? 'text-gray-500' : 'text-gray-900'} shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px]`}
                            >
                                {teacherSignupDetails.grade === "" ? t('t35') : teacherSignupDetails.grade}
                                <ChevronDownIcon
                                    aria-hidden="true"
                                    className="absolute right-[10px] size-5 text-gray-700"
                                />
                            </MenuButton>
                        </div>

                        <MenuItems
                            transition
                            className="absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                            style={{
                                width: '100%',
                                maxHeight: '100px', // Set a reasonable max height
                                overflowY: 'auto' // Enable scrolling for overflow content
                            }}
                        >
                            <div className="py-1">
                                {
                                    gradeArray.map((gradeSelect, index) => (
                                        <MenuItem key={index}>
                                            <button
                                                className="truncate text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                                onClick={() => {
                                                    setteacherSignupDetails((prev) => ({ ...prev, grade: gradeSelect }))
                                                }}
                                            >
                                                {gradeSelect}
                                            </button>
                                        </MenuItem>
                                    ))
                                }
                            </div>
                        </MenuItems>
                    </Menu>
                </div>

                {errors.noGrade &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t36')}</p>
                }

                <div className="items-center mt-[20px] flex h-[50px] md:h-[60px] xl:h-[50px] 2xl:h-[60px]">
                    <Menu as="div" className="w-full relative inline-block text-left py-[20px]">
                        <div>
                            <MenuButton
                                className={`truncate pl-[20px] inline-flex w-full justify-left items-center rounded-md bg-[#F1F6FB] h-[50px] md:h-[60px] xl:h-[50px] 2xl:h-[60px] text-[15px] ${teacherSignupDetails.class === "" ? 'text-gray-500' : 'text-gray-900'} shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px]`}
                            >
                                {teacherSignupDetails.class === "" ? t('t37') : teacherSignupDetails.class}
                                <ChevronDownIcon
                                    aria-hidden="true"
                                    className="absolute right-[10px] size-5 text-gray-700"
                                />
                            </MenuButton>
                        </div>

                        <MenuItems
                            transition
                            className="absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                            style={{
                                width: '100%',
                                maxHeight: '100px', // Set a reasonable max height
                                overflowY: 'auto' // Enable scrolling for overflow content
                            }}
                        >
                            <div className="py-1">
                                {
                                    classArray.map((classSelect, index) => (
                                        <MenuItem key={index}>
                                            <button
                                                className="truncate text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                                onClick={() => {
                                                    setteacherSignupDetails((prev) => ({ ...prev, class: classSelect }))
                                                }}
                                            >
                                                {classSelect}
                                            </button>
                                        </MenuItem>
                                    ))
                                }
                            </div>
                        </MenuItems>
                    </Menu>
                </div>

                {errors.noClass &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t38')}</p>
                }

                <div className="items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdMobileFriendly size="24px" color="#8189B0" />
                    <input type="text" name="mobile" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t57')}
                        onChange={(e) => {
                            setteacherSignupDetails((prevState) => ({
                                ...prevState, mobileNumber: e.target.value
                            }))
                        }}
                    />
                </div>
                {errors.noMobileNumber &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t58')}</p>
                }
                {errors.noValidMobileNumber &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t59')}</p>
                }

                <div className='flex items-center justify-center mt-[15px]'>
                    <input type='checkbox' name='regulations'
                        checked={checked} onChange={handleClickOpen} />
                    <label className='text-[14px] text-black ml-[10px]'>{t('t46')}</label>
                </div>

                {/* <button onClick={handleContinue} className="text-[18px] mt-[15px] rounded-lg pt-[10px] pb-[10px] w-full hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E] ">{t('t52')}</button> */}
                <button onClick={handleContinue} disabled={isLoading} className="text-[18px] mt-[15px] rounded-lg pt-[10px] pb-[10px] w-full hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E] ">
                    {isLoading ? (
                        <div className="items-center justify-center flex">
                            <div className='w-5 h-5 border-2 border-t-transparent border-white rounded-full animate-spin'></div>
                        </div>
                    ) : (
                        t('t52')
                    )}
                </button>
                {errors.noAgree &&
                    <div className='items-center justify-center flex'><p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t47')}</p></div>
                }
                <p className="text-black text-[15px] text-center mt-[10px] font-bold mb-[20px]">{t('t8_2')} <span onClick={() => (navigate('/loginas'))} className="text-[#FDC50C] hover:cursor-pointer hover:underline">{t('t25')}</span></p>


                <Dialog
                    open={open}
                    onClose={(event, reason) => {
                        if (reason !== "backdropClick") {
                            handleClose(); // Allow closing only for other reasons
                        }
                    }}
                    aria-labelledby="custom-dialog-title"
                    aria-describedby="custom-dialog-description"
                    className="backdrop-blur-sm"
                >
                    <DialogTitle
                        id="custom-dialog-title"
                        className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                    >
                        {t('t53')}
                    </DialogTitle>
                    <DialogContent className="bg-gray-50">
                        <p className='mt-[20px] text-black'>{t('t394')}</p>
                        <p className='mt-[20px] text-black'>{t('t395')}</p>
                        <p className='ml-[20px] text-black'>{t('t396')}</p>
                        <p className='mt-[20px] text-black'>{t('t397')}</p>
                        <p className='ml-[20px] text-black'>{t('t398')}</p>
                        <p className='mt-[20px] text-black'>{t('t399')}</p>
                        <p className='ml-[20px] text-black'>{t('t400')}</p>
                        <p className='mt-[20px] text-black'>{t('t401')}</p>
                        <p className='ml-[20px] text-black'>{t('t402')}</p>
                        <p className='mt-[20px] mb-[20px] text-black'>{t('t403')}</p>

                    </DialogContent>
                    <DialogActions className="px-4 py-2">
                        <Button
                            onClick={handleClose}
                            className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                            style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                        >
                            {t('t51')}
                        </Button>
                        <Button
                            onClick={handleAgree}
                            className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                            style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                        >
                            {t('t50')}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={open2}
                    onClose={(event, reason) => {
                        if (reason !== "backdropClick") {
                            handleClose2(); // Allow closing only for other reasons
                        }
                    }}
                    aria-labelledby="custom-dialog-title"
                    aria-describedby="custom-dialog-description"
                    className="backdrop-blur-sm"
                >
                    <DialogContent className="bg-[#FFF6DA]">

                        <DialogContent
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            <div className='flex flex-col justify-center items-center text-center'>
                                <img src='/images/success.svg' alt='success' />
                                <div className='mt-[30px]'>{t('t54')}</div>
                            </div>
                        </DialogContent>

                    </DialogContent>
                    <DialogActions
                        style={{
                            backgroundColor: '#FFF6DA',
                            display: 'flex',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <Button
                            onClick={() => {
                                localStorage.removeItem('teachersignup2');
                                localStorage.removeItem('teachersignup1');
                                navigate('/loginas');
                            }}
                            style={{
                                backgroundColor: '#F2AC0E',
                                color: 'white',
                                padding: '10px 20px', // px-4 py-2
                                borderRadius: '0.375rem', // rounded-md
                                fontWeight: 'bold',
                            }}
                        >
                            {t('t7')}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={openError}
                    onClose={(event, reason) => {
                        if (reason !== "backdropClick") {
                            handleCloseError(); // Allow closing only for other reasons
                        }
                    }}
                    aria-labelledby="custom-dialog-title"
                    aria-describedby="custom-dialog-description"
                    className="backdrop-blur-sm"
                >
                    <DialogTitle
                        id="custom-dialog-title"
                        className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                    >
                        {t('t95')}
                    </DialogTitle>
                    <DialogContent className="bg-gray-50">
                        <DialogContentText
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            {error}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className="px-4 py-2">
                        <Button
                            onClick={handleCloseError}
                            className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                            style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                        >
                            {t('t96')}
                        </Button>
                    </DialogActions>
                </Dialog>

            </div>
        </div>
    );
}

export default TeacherSignUp2;